<template>
    <div class="task-list">
        <template>
            <ul class="con-list"
                v-if="list.length && loading">
                <template v-for="li in list">
                    <p class='l-time'>{{li.text_time }} </p>
                    <li v-for="l,index in li.list">
                        <div class='task_box'>
                            <div :class="['l-title',l.sid == 21||l.sid == 22?'l-title-sx':l.sid == 51?'l-title-yw':'l-title-yy']"></div>
                            <div class="l-box">
                                <div class="task-title">{{l.test_name}}</div>
                                <p>截止时间：{{l.end_time}}</p>
                            </div>
                            <span :class="[`task_status`,l.status===0||l.status===1||l.status===3||l.status===4?'not_task_status':'yes_task_status']">{{l.status===0||l.status===1||l.status===3||l.status===4?`未完成`:`已完成`}}</span>
                            <!-- # 0做作业， 1继续作业，2已完成  3 补交作业   -->
                            <!-- <a href="javascript:;" v-if='l.status===2||l.status===5' :class="[l.confirm?`gray`:`blove`]" @click="toTask(l)">{{l.confirm?`已确认`:`去确认`}}</a> -->
                            <a href="javascript:;"
                               v-if='l.status===2||l.status===5'
                               class="blove"
                               @click="toTask(l)">查看</a>
                        </div>
                    </li>
                </template>
            </ul>
            <no-resouse v-else-if='!list.length && loading'></no-resouse>
            <more-Loading v-show='moreLoading'></more-Loading>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
import noResouse from 'SRC/components/noResouse.vue';
import moreLoading from 'SRC/components/moreLoading.vue';
export default {
    data () {
        return {
            list: [],
            loading: false,//接口是否已返回数据
            task_text: ['做作业', '继续作业', '查看结果', '补交作业', '参加活动', '查看结果'],
            // # 0做作业， 1继续作业，2已完成  3 补交作业  
            outside_text: [],
            page: 1,//分页
            class_id: this.$route.query.class_id,//班级ID
            loadMoreTimer: null,//上拉加载定时器
            loadOver: false,//上拉加载加锁
            titles: '在线作业',
            moreLoading: false,
            totalList: [],
        }
    },
    components: {
        loadingS, noResouse, moreLoading
    },
    filters: {

    },
    methods: {
        toTask (l) {
            let _data = { "task_type": l.task_type, "message_id": l.id, "sid": l.sid };
            // this.$store.dispatch('confirmAdd',_data);// zd 2019.06.25
            let url = '';
            if (l.sid === 21 || l.sid === 22) {
                //数学做题
                if (l.test_name === '知识点视频') {
                    //结果页和做题页是同一页面，无需判断
                    url = '/sx/knowledge/watchVideo/' + l.id + '?sid=' + l.sid + '&title=练习详情' + '&rid=' + l.recomment_id;
                } else if (l.test_name === '速算作业') {
                    if (l.status === 2) {
                        url = '/sx/quick/doresult/' + l.id + '?sid=' + l.sid + '&rid=' + l.recomment_id + '&title=练习详情';
                    } else {
                        url = '/sx/quick/dowork/' + l.id + '?sid=' + l.sid
                    }
                } else if (l.test_name === '同步习题' || l.test_name === '单元复习' || l.test_name === '高频错题') {
                    if (l.status === 2) {
                        url = '/sx/taskresult/' + l.id + '?sid=' + l.sid + '&rid=' + l.recomment_id + '&title=练习详情';
                    } else {
                        url = '/sx/dowork/' + l.id + '?sid=' + l.sid
                    }
                } else if (l.test_name === '课外活动') {
                    // try {appobject.Interactive(`ys_kwhd_detail,${l.id}`);} catch (e) {//console.log(e)}
                    this.appFunction("ys_kwhd_detail", `${l.id}`);
                }
            } else if (l.sid === 91 || l.sid === 92) {
                //英语作业
                // this.$store.state.english.task_name = `练习详情`;
                if (l.task_type == 1) {
                    // 课前预习
                    // try {appobject.Interactive(`ys_task_list_eng,${l.id},${'91'},${l.recomment_id}`);} catch (e) {}
                    this.appFunction("ys_task_list_eng", `${l.id},${'91'},${l.recomment_id}`);
                    return false
                } else if (l.task_type == 2 && l.sid === 91) {
                    // 同步习题
                    if (l.status == 2) {
                        url = '/english/taskresult/' + l.id + '/' + l.sid + '?rid=' + l.recomment_id + '&title=练习详情';
                    } else {
                        url = '/english/dotask/' + l.id + '/' + l.sid
                    }
                } else if (l.task_type == 2 && l.sid === 92) {
                    // 同步习题
                    if (l.status == 2) {
                        url = '/english2/taskresult/' + l.id + '/' + l.sid + '?rid=' + l.recomment_id + '&title=练习详情';
                    } else {
                        url = '/english2/dotask/' + l.id + '/' + l.sid
                    }
                } else if (l.task_type === 3) {
                    // try {appobject.Interactive(`ys_kwhd_detail,${l.id}`);} catch (e) {//console.log(e)}
                    this.appFunction("ys_kwhd_detail", `${l.id}`);
                }
            } else if (l.sid === 51) {
                //语文作业
                // sid = 51
                // task_type 1 课前预习
                // task_type 2 课后联系
                // test_type === 1  同步习题
                // test_type === 2  单元复习
                // test_type === 3  高频错题
                // test_type === 4  生词听写    /chinese/doread/list/:id
                // task_type 3 课外拓展
                //task_type 4
                //test_type 1 课外阅读
                if (l.task_type == 1) {
                    // 课前预习
                    // try {appobject.Interactive(`ys_task_list_chinese,${l.id},${l.recomment_id}`);} catch (e) {//console.log('课前预习')}
                    this.appFunction("ys_task_list_chinese", `${l.id},${l.recomment_id}`);
                    return false
                } else if (l.task_type == 2) {
                    // 课后练习
                    if (l.test_type == 1 || l.test_type == 2 || l.test_type === 3) {//同步习题 单元复习 高频错题
                        if (l.status == 2) {
                            url = "/chinese/tast/result/" + l.id + '?rid=' + l.recomment_id + '&title=练习详情';
                        } else {
                            url = '/chinese/tast/do/' + l.id;
                        }
                        // return false
                    } else if (l.test_type == 4) {
                        // 生词听写
                        if (l.status == 2) {// 结果页
                            // try {appobject.Interactive(`ys_task_sctx_result,${l.id},${l.recomment_id}`);} catch (e) {//console.log(' 结果页')}
                            this.appFunction("ys_task_sctx_result", `${l.id},${l.recomment_id}`);
                            return false
                        } else {// 做作业
                            // try {appobject.Interactive(`ys_task_sctx_do,${l.id}`);} catch (e) {//console.log(' 做作业')}
                            this.appFunction("ys_task_sctx_do", `${l.id}`);
                            return false
                        }
                    }
                } else if (l.task_type == 3) {//课外拓展
                    if (l.test_name === '课外活动') {
                        // try {appobject.Interactive(`ys_kwhd_detail,${l.id}`);} catch (e) {//console.log(e)}
                        this.appFunction("ys_kwhd_detail", `${l.id}`);
                        return false
                    }
                } else if (l.task_type == 4) {//
                    if (l.test_type == 1) {//课外阅读
                        url = '/chinese/doread/list/' + l.id + '?rid=' + l.recomment_id + '&title=练习详情';
                    }
                }
            }
            if (url.length) {
                this.Primordial(url);
            }
        },
        Primordial (url) {
            if (url) {
                // 除了课外作业  其他的作业需要新来页面  调原生的方法
                let urls = VUE_URL_TASK + url;
                // try {
                //   appobject.Interactive(`ys_task_detail,${urls}`);
                // } catch (e) {
                //   // vue 调试的时候解开  上线的时候要注释
                //   this.$router.push(url)
                // }
                this.appFunction("ys_task_detail", `${urls}`, url);
            }
        },
        mapList (arr) {
            let newArr = [];
            arr.forEach((oldtime, i) => {
                let index = -1;
                let is_True = newArr.some((newtime, j) => {
                    if (oldtime.text_time === newtime.text_time) {
                        index = j;
                        return true;
                    }
                });
                if (!is_True) {
                    newArr.push({
                        text_time: oldtime.text_time,
                        list: [oldtime]
                    });
                } else {
                    newArr[index].list.push(oldtime);
                }
            });
            this.list = newArr;
        },
        getList () {
            let _data = {}
            _data.p = this.page
            if (this.class_id) {
                _data.unit_class_id = this.class_id
            }
            this.$http.post(API_URL_TASK_API + '/public/task/stu/confirm/list', _data).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    if (res.data.length) {
                        this.page++;
                        this.totalList = this.totalList.concat(res.data);
                        this.mapList(this.totalList);
                    } else if (!res.data.length && this.page != 1) {
                        this.loadOver = true;
                        this.moreLoading = false
                        layer.tips('已加载全部内容');
                    }
                    this.loading = true;
                    this.moreLoading = false;
                }
            })
        },
        loadMore () {
            let that = this;
            this.loadMoreTimer && clearTimeout(this.loadMoreTimer);
            this.loadMoreTimer = setTimeout(function () {
                let docHeight = document.body.scrollHeight || document.documentElement.scrollHeight;
                let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                let winHeight = window.screen.availHeight;
                if (winHeight + scrollTop >= docHeight - 20) {
                    if (!that.loadOver) {
                        that.moreLoading = true;
                        that.getList();
                    }
                }
            }, 500)
        },
    },
    destroyed () {
        clearInterval(this.loadMoreTimer);
        window.removeEventListener('scroll', this.loadMore, true)
    },
    created () {
        this.getList();
        window.addEventListener('scroll', this.loadMore, true)
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.task-list {
    min-height: 100vh;
    background: #f5f5f5;
    .header-wrap {
        background: #fff;
        .header {
            background: #fff;
            font-size: 36px / $ppr;
            color: #333;
            .left {
                display: block;
                width: 20px / $ppr;
                height: 33px / $ppr;
                background: url("./img/gray_back.png") 0 0 no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .con-list {
        padding-bottom: 24px / $ppr;
        position: relative;
        .l-time {
            font-size: 24px / $ppr;
            margin: 40px / $ppr 0 30px / $ppr;
            text-indent: 0.5rem;
            color: #999999;
            text-align: center;
            &:nth-of-type(1) {
                margin: 0;
                padding: 40px / $ppr 0 30px / $ppr;
            }
        }
        .task_box {
            position: relative;
            margin: 0 auto 0.6rem;
            width: 672px / $ppr;
            height: 176px / $ppr;
            background: #fff;
            border-radius: 10px / $ppr;
            .icon_reward {
                display: block;
                position: absolute;
                top: 0;
                right: 0;
                width: 81px / $ppr;
                height: 75px / $ppr;
                background: url("./img/teareward.png") 0 0 no-repeat;
                background-size: 100% 100%;
            }
            .l-title {
                width: 96px / $ppr;
                height: 96px / $ppr;
                position: absolute;
                top: 50%;
                left: 30px / $ppr;
                transform: translate(0, -50%);
            }
            .l-title-sx {
                background: url("./img/icon_sx_title.png") no-repeat;
                background-size: 100% 100%;
            }
            .l-title-yy {
                background: url("./img/icon_yy_title.png") no-repeat;
                background-size: 100% 100%;
            }
            .l-title-yw {
                background: url("./img/icon_yw_title.png") no-repeat;
                background-size: 100% 100%;
            }

            .l-box {
                position: absolute;
                top: 50%;
                left: 140px / $ppr;
                transform: translate(0, -50%);
                .task-title {
                    display: block;
                    font-size: 30px / $ppr;
                    color: #333;
                    i {
                        display: inline-block;
                        margin-left: 20px / $ppr;
                        width: 38px / $ppr;
                        height: 38px / $ppr;
                        vertical-align: middle;
                        &.icon-sx {
                            background: url("./img/icon-sx.png") 0 0 no-repeat;
                            background-size: 100% 100%;
                        }
                        &.icon-yw {
                            background: url("./img/icon-yw.png") 0 0 no-repeat;
                            background-size: 100% 100%;
                        }
                        &.icon-yy {
                            background: url("./img/icon-yy.png") 0 0 no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                    em {
                        display: inline-block;
                        margin-left: 20px / $ppr;
                        width: 68px / $ppr;
                        height: 38px / $ppr;
                        background: url("./img/icon-activity.png") 0 0 no-repeat;
                        background-size: 100% 100%;
                        vertical-align: middle;
                    }
                }
                p {
                    margin-top: 20px / $ppr;
                    font-size: 24px / $ppr;
                    color: #999;
                }
            }
            .task_status {
                position: absolute;
                top: 67px / $ppr;
                right: 24px / $ppr;
                margin-top: -0.8rem;
                width: 126px / $ppr;
                height: 56px / $ppr;
                line-height: 56px / $ppr;
                text-align: center;
                border-radius: 0.8rem;
                font-size: 24px / $ppr;
            }
            .yes_task_status {
                color: #999999;
            }
            .not_task_status {
                color: #ff1618;
            }
            a {
                position: absolute;
                top: 87px / $ppr;
                right: 24px / $ppr;
                // margin-top: -32px/$ppr;
                width: 126px / $ppr;
                height: 56px / $ppr;
                line-height: 56px / $ppr;
                text-align: center;
                border-radius: 32px / $ppr;
                color: #fff;
                &.blove {
                    background: #5dd6ff;
                }
                &.orange {
                    background: #ffa96b;
                }
                &.green {
                    background: #78e5a4;
                }
                &.gray {
                    background: #e0e0e0;
                }
            }
        }
    }
}
.uptip {
    display: none;
    padding: 22px / $ppr 24px / $ppr;
    font-size: 30px / $ppr;
    line-height: 50px / $ppr;
    color: #ff6600;
    background-color: #fffae4;
}
</style>
